export default __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-mini-lg-ded39b105851df35c89396939eb28d3d.png";